<template>
  <div>
    <div class="d-flex justify-content-end mb-2">
      <!-- <b-button :to=>Location Details</b-button> -->
      <b-button
        size="sm"
        class="mr-2"
        :disabled="!isValidPrimaryLocation"
        @click="onSetPrimary"
      >Make Primary Location</b-button>
      <b-button size="sm" @click="showAddEditLocationModal()">Add Location</b-button>
    </div>
    <grid
      has-edit
      has-delete
      has-pagination
      grid-id="locations-grid"
      :fields="fields"
      :items="locations"
      :get-items-function="getLocationsData"
      :total-rows="locationPaging.totalItems"
      :current-page="locationPaging.pageNumber"
      :per-page="locationPaging.pageSize"
      :sort-by="locationPaging.sortBy"
      :sort-order="locationPaging.sortOrder"
      :indicator="primaryValue"
      :no-records="'No associated locations found'"
      @click-row="onSelectLocation"
      @edit="showAddEditLocationModal($event)"
      @delete="onDeleteLocation"
    />

    <!--  MODAL  -->
    <b-modal
      ref="addEditLocationModal"
      :title="this.modalTitle"
      ok-title="Save Company Location"
      size="xl"
      @ok="onSaveCompanyLocationRecord"
    >
      <location-form
        ref="locationForm"
        :company-id="companyId"
        :company="companyObj"
        :update-company-location="saveCompanyLocationRecord"
      ></location-form>
    </b-modal>
  </div>
</template>

<script>
//import gridFields from '../../../../../fields';

import Grid from '@/shared/components/Grid';
import LocationForm from './Form';
import _ from 'lodash';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

export default {
  components: {
    Grid,
    LocationForm
  },
  props: ['companyId'],
  data() {
    return {
      fields: [
        { key: 'commands', label: '', tdClass: 'grid-commands-width-1' },
        { key: 'name', label: 'Name' },
        { key: 'isPrimary', label: 'Primary' },
        {
          key: 'physicalAddress1',
          label: 'Physical Address 1'
        },
        {
          key: 'physicalAddress2',
          label: 'Physical Address 2'
        },
        { key: 'physicalCity', label: 'City' },
        { key: 'physicalState', label: 'State/Province' },
        { key: 'physicalZipcode', label: 'Postal Code' }
      ],
      selectedLocation: 0,
      modalTitle: '',
      saveCompanyLocationRecord: false,
      companyObj: {}
    };
  },
  computed: {
    ...mapGetters('companies', [
      'locations',
      'pageInfo',
      'sortBy',
      'sortOrder',
      'searchQuery',
      'selectedId'
    ]),
    ...mapState('companies', [
      'locations',
      'locationPaging',
      'primaryLocation'
    ]),
    isValidPrimaryLocation() {
      return (
        this.selectedLocation != 0 &&
        this.primaryLocation != this.selectedLocation
      );
    }
  },
  watch: {
    companyId: {
      handler() {
        this.getLocationsData();
      }
    }
  },
  methods: {
    ...mapActions('companies', [
      'getLocations',
      'setPrimaryLocation',
      'deleteLocation'
    ]),
    onSelectLocation(item) {
      this.selectedLocation = this.selectedLocation == item.id ? 0 : item.id;
    },
    onSetPrimary() {
      this.setPrimaryLocation(this.selectedLocation);
    },
    showAddEditLocationModal(location = {}) {
      let isEmptyLocation = _.isEmpty(location);
      this.modalTitle = isEmptyLocation ? 'Add' : 'Edit';
      this.companyObj = isEmptyLocation ? {} : location;
      this.modalTitle += ' Company Location';
      this.$refs['addEditLocationModal'].show();
    },
    onSaveCompanyLocationRecord(event) {
      console.log('Company LocationSaved');
      event.preventDefault();
      this.$refs.locationForm.$v.$touch();
      if (this.$refs.locationForm.$v.$invalid) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.addEditLocationModal.hide();
      });
      this.saveCompanyLocationRecord = Date.now();
    },
    async getLocationsData(pagingData) {
      await this.getLocations({ companyId: this.companyId, ...pagingData });
    },
    primaryValue(data) {
      return data.item.isPrimary ? '<i class="fa fa-check"></i>' : '';
    },
    async onDeleteLocation(data) {
      if (!data.isPrimary) {
        await this.deleteLocation([data.id, this.companyId]);
      } else {
        this.$bvModal.msgBoxOk('Cannot delete a Primary Location');
      }
    }
  }
};
</script>